import React, { useState } from "react";
import {
  Label,
  OptionItem,
  OptionList,
  OptionsContainer,
  SelectButton,
} from "./index.styled";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

export interface Option {
  value: string;
  label: string;
}

interface CurrencySelectProps {
  currentOption: Option;
  setOption: (option: Option) => void;
  options: Option[];
  color?: string;
}
const SelectComponent: React.FC<CurrencySelectProps> = ({
  options,
  setOption,
  currentOption,
  color = "black",
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  return (
    <SelectButton color={color} onClick={() => setIsOpen(!isOpen)}>
      <Label>
        {currentOption.label}
        {isOpen ? <FiChevronUp /> : <FiChevronDown />}
      </Label>

      <OptionsContainer show={isOpen}>
        <OptionList>
          {options?.map((o, index) => (
            <OptionItem key={index} onClick={() => setOption(o)}>
              {o.label}
            </OptionItem>
          ))}
        </OptionList>
      </OptionsContainer>
    </SelectButton>
  );
};

export default SelectComponent;
